/* Collaborations form (sections/ac-cb-page.liquid).

   Two small behaviours on top of Shopify's contact form, both optional —
   the form posts fine without them:

   1. A URL typed without a scheme gets https:// on change and on submit,
      so the browser's URL validation does not reject "instagram.com/…".
   2. The submit button locks with a "Sending…" label once the browser's
      constraint validation has passed, so a double tap cannot post twice.

   Re-runs safely when the theme editor re-renders the section. */
(function () {
  'use strict';

  function addScheme(input) {
    var v = input.value.trim();
    if (v && !/^[a-z][a-z0-9+.-]*:/i.test(v)) input.value = 'https://' + v;
  }

  function init(root) {
    var form = root.querySelector('[data-ac-cb-form]');
    if (!form || form.dataset.acCbReady) return;
    form.dataset.acCbReady = '1';

    var urls = form.querySelectorAll('[data-ac-cb-url]');
    var submit = form.querySelector('[data-ac-cb-submit]');
    var notice = form.querySelector('[data-ac-cb-notice]');
    var submitLabel = submit ? submit.textContent : '';

    for (var j = 0; j < urls.length; j++) {
      urls[j].addEventListener('change', function (e) { addScheme(e.target); });
    }

    form.addEventListener('submit', function (e) {
      for (var k = 0; k < urls.length; k++) addScheme(urls[k]);
      if (!form.checkValidity()) return;
      if (form.dataset.acCbSending) { e.preventDefault(); return; }
      form.dataset.acCbSending = '1';
      if (submit) {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        if (submit.dataset.sendingLabel) submit.textContent = submit.dataset.sendingLabel;
      }
    });

    // Back/forward cache can restore a locked button; unlock it.
    window.addEventListener('pageshow', function () {
      delete form.dataset.acCbSending;
      if (submit) { submit.disabled = false; submit.removeAttribute('aria-busy'); submit.textContent = submitLabel; }
    });

    // Put the server's success / error notice in front of assistive tech.
    if (notice) notice.focus({ preventScroll: false });
  }

  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
